export default {
  'title': 'Il est temps de mettre à jour votre navigateur !',
  'subtitle':
    'Nous ne supportons plus votre ancienne version de navigateur. Pour continuer à naviguer sur mon-marche.fr, merci de mettre à jour votre navigateur.',
  'switch-category': 'Changer de rayon ?',
};
